import * as microsoftTeams from '@microsoft/teams-js';

export async function getSSOToken() {
  return new Promise((resolve, reject) => {
    microsoftTeams.authentication.getAuthToken({
      successCallback: (token) => resolve(token),
      failureCallback: (error) => reject(error),
    });
  });
}
